export default [{
  name: 'Evaluation',
  key: 'menu.performance_evaluation_sub.evaluation',
  subname: '',
  href: {
    name: 'performance_evaluation'
  },
  link: '/performance-evaluation/evaluation',
  roles: []
}];